import React from "react"
import moment from 'moment'
import { Table, Divider, Space, Button, Row, Col, Modal, message } from "antd"
import { Link } from "react-router-dom"

import { AdminService } from "@/services"
import CommonLayout from "@/common/Layout"

import PackageEditFormModal from "./editFormModal"

class PublicComponentPackagesPage extends React.PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      ready: false,
      packageList: [],
      isCreating: false,
      editingPackage: null
    }
  }

  async componentDidMount() {
    this.refreshPackageList()
  }

  async refreshPackageList() {
    const params = { page: 1, page_size: 5000 }
    const response = await AdminService.get_public_component_package_list(params)

    const dataBody = response.data.body

    this.setState({
      ready: true,
      packageList: dataBody.packages
    })
  }

  async handleSubmitCreatePackage(formData) {

    // console.log("todo handleSubmitCreatePackage", formData)

    const params = {
      key: formData.key,
      name: formData.name,
      file: formData.file
    }
    const response = await AdminService.create_public_component_package(params)

    const { status, body } = response.data
    if (status <= 0) {
      return message.error("创建失败，请稍后重试！")
    }

    this.refreshPackageList()
    this.setState({ isCreating: false })

    message.success("保存成功")
  }

  async handleSubmitUpdatePackage(packageId, formData) {

    // console.log("todo handleSubmitUpdatePackage", packageId, formData)

    const params = {
      package_id: packageId,
      key: formData.key,
      name: formData.name
    }

    if (formData.file) {
      params.file = formData.file
    }

    const response = await AdminService.update_public_component_package(params)

    const { status, body } = response.data
    if (status <= 0) {
      return message.error("保存失败，请稍后重试！")
    }

    this.refreshPackageList()
    this.setState({ editingPackage: null })

    message.success("保存成功")
  }

  handleClickDeletePackage(packge) {
    Modal.confirm({
      title: `确认要删除代码包"${packge.name}"吗？`,
      content: '删除后将不可恢复，请谨慎操作',
      okText: "确认",
      cancelText: "取消",
      onOk: async () => {
        // console.log("todo deletePackage", packge)
        const params = {
          package_id: packge.id
        }

        const response = await AdminService.delete_public_component_package(params)
        const { status, body } = response.data
        if (status <= 0) {
          return message.error("删除失败，请稍后重试！")
        }

        this.refreshPackageList()
        message.success("删除成功")
      }
    })
  }

  downloadPackage(packge) {
    window.open(packge.downloadUrl)
  }

  renderNewModal() {
    const { isCreating } = this.state
    if (!isCreating) return null

    const formData = {}

    return (
      <PackageEditFormModal
        isNew={true}
        title="上传代码包"
        formData={formData}
        onCancel={() => this.setState({ isCreating: false })}
        onSubmit={(formData) => this.handleSubmitCreatePackage(formData)}
      />
    )
  }

  renderEditModal() {
    const { editingPackage } = this.state
    if (!editingPackage) return null

    return (
      <PackageEditFormModal
        isNew={false}
        title="编辑代码包"
        formData={editingPackage}
        onCancel={() => this.setState({ editingPackage: null })}
        onSubmit={(formData) => this.handleSubmitUpdatePackage(editingPackage.id, formData)}
      />
    )
  }

  renderPackagesTable() {

    const { ready, packageList } = this.state
    if (!ready) return null

    const columns = [
      {
        title: '代码包名称',
        dataIndex: 'name',
        key: 'name',
        align: "center"
      },
      {
        title: "代码包标识",
        dataIndex: "key",
        key: "key",
        align: "center"
      },
      {
        title: "规格版本号",
        dataIndex: "specVersion",
        key: "specVersion",
        align: "center",
      },
      {
        title: '操作',
        key: 'action',
        align: "center",
        render: (text, record) => (
          <Space>
            <Link to={`/publicComponents/packageComponents?packageId=${record.id}`} tag="a">
              <span style={{ display: "inline-block" }}>组件列表</span>
            </Link>
            <Divider type="vertical" />
            <a onClick={() => this.setState({ editingPackage: record })} style={{ display: "inline-block" }}>编辑</a>
            <Divider type="vertical" />
            <a onClick={() => this.handleClickDeletePackage(record)} style={{ display: "inline-block" }}>删除</a>
            <Divider type="vertical" />
            <a onClick={() => this.downloadPackage(record)} style={{ display: "inline-block" }}>下载</a>
          </Space>
        )
      },
    ];

    return (
      <Table
        dataSource={packageList}
        columns={columns}
        rowKey="id"
        pagination={false}
      />
    )
  }

  render() {

    return (
      <CommonLayout selectedMenuKey="publicComponentsPackages" openMenuKeys={["groupPublicComponents"]}>
        <Row>
          <Col span={16}>
            <h2>组件代码包</h2>
          </Col>
          <Col span={8} style={{ textAlign: "right" }}>
            <Button type="primary" onClick={() => this.setState({ isCreating: true })}>上传代码包</Button>
          </Col>
        </Row>

        <div style={{ marginBottom: 20 }}>
          {this.renderPackagesTable()}
        </div>

        {this.renderNewModal()}
        {this.renderEditModal()}
      </CommonLayout>
    )
  }
}

export default PublicComponentPackagesPage
